import React, { ReactNode } from 'react';

export type KbdProps = {
  children?: ReactNode;
};

export function Kbd({ children }: KbdProps) {
  return (
    <kbd
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        minWidth: 20, height: 20, padding: '0 5px',
        borderRadius: 4,
        background: 'var(--bg-fill-1)',
        color: 'var(--fg-secondary)',
        fontSize: 11, fontWeight: 600,
        fontFamily: 'var(--font-mono)',
        border: '1px solid var(--line-divider)',
      }}
    >
      {children}
    </kbd>
  );
}

export default Kbd;
